module.exports = "https://static.im-cdn.com/mjc/storefront/Cipher/static/media/InviteBanner.67a433ae.jpg";